import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowedUsers } from "src/contexts"
import { followToSharer } from "src/utils"

interface Props {
  user: "account" | "follow"; // show account name or current follow name
  transform?: (follow: Follow) => string;
}

export function UserName(props: Props) {
  const {
    user,
    transform = followToSharer,
  } = props

  const {
    selfFollow,
    currentFollow,
  } = useFollowedUsers()

  const follow = user === "account" ? selfFollow : currentFollow

  const userName = useMemo(
    () => transform(follow),
    [
      follow,
      transform,
    ],
  )

  return (
    <>
      {userName}
    </>
  )
}
